import { createBrowserRouter } from "react-router-dom";
import Agreement from "./pages/agreement/agreement";
import Autopayment from "./pages/autopayment/autopayment";
import Contract from "./pages/contract/contract";
import Password from "./pages/password/password";
import Payments from "./pages/payments/payments";
import Profile from "./pages/profile/profile";
import Sputnik from "./pages/sputnik/sputnik";
import Bonus from "./pages/bonus/bonus";
import PasswordRecovery from "./pages/password/passwordRecovery";
import Notifications from "./pages/notifications/notifications";
import ProtectedRoute from "./components/common/ProtectedRoute";
import Chat from "./pages/chat/chat";
import ChatHomepage from "./pages/chat/chatHomepage";
import ChatConversation from "./pages/chat/chatConversation";
import ChatWidgetProvider from "./providers/ChatWidgetProvider";

const routes = [
  {
    path: "/",
    element: <Sputnik />,
  },
  {
    path: "/agreement",
    element: <Agreement />,
  },
  {
    path: "/autopayment",
    element: <Autopayment />,
  },
  {
    path: "/contract",
    element: <Contract />,
  },
  {
    path: "/password",
    element: <Password />,
  },
  {
    path: "/payments",
    element: <Payments />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/review-and-bonus",
    element: <Bonus />,
  },
  {
    path: "/singup/:pair",
    element: <PasswordRecovery />,
  },
  {
    path: "/notifications",
    element: <Notifications />,
  },
  {
    path: "/chat",
    element: <ProtectedRoute />,
    children: [
      {
        element: (
          <ChatWidgetProvider>
            <Chat />
          </ChatWidgetProvider>
        ),
        children: [
          {
            index: true,
            element: <ChatHomepage />,
          },
          {
            path: ":userId/conversation",
            element: <ChatConversation />,
          },
        ],
      },
    ],
  },
];

export const router = createBrowserRouter(routes);
